const jQ = jQuery.noConflict();
const hamburger = jQ('.btn-hamburger');
const imgWrapper = jQ('.header__images-wrapper');
const contWrapper = jQ('.main-header__overlay-content');
const overlay = jQ('.main-header__overlay');
const images = jQ('.image-wrapper');
const innerTrigger = jQ('.inner-trigger');
const checker = window.matchMedia('screen and (min-width: 1025px)');

function animateImage() {
    hamburger.on('click', () => {
        if (hamburger.hasClass('open')) {
            let delayTime = 0;
            jQ(jQ('.accordion-trigger').get().reverse()).each(function () {
                jQ(this).delay(delayTime).animate({ left: '20%', opacity: '0' }, '100');
                delayTime += 100;
            });

            setTimeout(() => {
                if (checker.matches) {
                    imgWrapper.toggle('blind', { direction: 'horizontal' }, 600);
                }
                contWrapper.removeClass('move-left');
                setTimeout(() => {
                    overlay.removeClass('visible');
                }, 600);
            }, 400);
        } else {
            if (checker.matches) {
                imgWrapper.toggle('blind', { direction: 'horizontal' }, 600);
            }
            contWrapper.addClass('move-left');
            setTimeout(() => {
                let delayTime = 0;
                jQ('.accordion-trigger').each(function () {
                    jQ(this).delay(delayTime).animate({ left: '0px', opacity: '1' }, '300');
                    delayTime += 100;
                });
            }, 200);
        }
    });
}

function changeImage() {
    // change image on hover
    innerTrigger.on('mouseover', function () {
        const dataAttr = jQ(this).attr('data-image');

        images.removeClass('visible');
        jQ(`[data-image= ${dataAttr}]`).addClass('visible');
    });

    // change image to default one when mouseout
    innerTrigger.on('mouseout', () => {
        // check on mouseout if any accordion item is active
        // if so, change default image to this accordion image
        if (jQ('.accordion-trigger.active').length > 0) {
            const that = jQ('.accordion-trigger.active');
            const dataAttr = that.find('.inner-trigger').attr('data-image');

            images.removeClass('visible current-visible-image');
            jQ(`[data-image= ${dataAttr}]`).addClass('visible current-visible-image');
        } else {
            // if accordion item is not active, change image to default
            images.removeClass('visible');
            images.first().addClass('visible');
        }
    });
}

function setCurrentImage() {
    if (jQ('.main-header__nav').find('.current_page_item').length > 0) {
        const that = jQ('.main-header__nav').find('.current_page_item');
        const dataAttr = that.closest('.current-menu-parent').find('.inner-trigger').attr('data-image');

        images.removeClass('visible current-visible-image');
        jQ(`[data-image= ${dataAttr}]`).addClass('visible current-visible-image');
    }
}

function headerImageInit() {
    animateImage();
    changeImage();
    setCurrentImage();
}

export default headerImageInit;
